import './player-page-skeleton.css';

/** 모바일 플레이어 진입 시 lazy chunk 로딩 — 히어로 레이아웃 스켈레톤 */
export function PlayerPageSkeleton() {
  return (
    <div
      className="soundpill-player-page soundpill-player-page--skeleton h-full min-h-0 w-full flex flex-col overflow-hidden bg-[#060818] text-white"
      aria-busy="true"
      aria-live="polite"
    >
      <div className="player-page-skeleton flex flex-1 min-h-0 min-w-0 flex-col overflow-hidden">
        <section className="player-page-skeleton__hero flex flex-1 min-h-0 flex-col items-center">
          <div className="player-page-skeleton__back player-page-skeleton__shimmer" aria-hidden />

          <div className="player-page-skeleton__album-zone flex-1 min-h-0 w-full flex items-center justify-center">
            <div className="player-page-skeleton__album player-page-skeleton__shimmer" aria-hidden />
          </div>

          <div className="player-page-skeleton__block player-page-skeleton__meta">
            <div
              className="player-page-skeleton__line player-page-skeleton__line--title player-page-skeleton__shimmer"
              aria-hidden
            />
            <div
              className="player-page-skeleton__line player-page-skeleton__line--sub player-page-skeleton__shimmer"
              aria-hidden
            />
          </div>

          <div className="player-page-skeleton__block player-page-skeleton__progress">
            <div className="player-page-skeleton__bar player-page-skeleton__shimmer" aria-hidden />
            <div className="player-page-skeleton__times">
              <div className="player-page-skeleton__time player-page-skeleton__shimmer" aria-hidden />
              <div className="player-page-skeleton__time player-page-skeleton__shimmer" aria-hidden />
            </div>
          </div>

          <div className="player-page-skeleton__transport" aria-hidden>
            <div className="player-page-skeleton__transport-icon player-page-skeleton__shimmer" />
            <div className="player-page-skeleton__transport-play player-page-skeleton__shimmer" />
            <div className="player-page-skeleton__transport-icon player-page-skeleton__shimmer" />
          </div>

          <div className="player-page-skeleton__toolbar" aria-hidden>
            <div className="player-page-skeleton__pill player-page-skeleton__shimmer" />
            <div className="player-page-skeleton__pill player-page-skeleton__shimmer" />
          </div>
        </section>
      </div>

      <div className="player-page-skeleton__drawer" aria-hidden>
        <div className="player-page-skeleton__drawer-handle player-page-skeleton__shimmer" />
        <div className="player-page-skeleton__drawer-line player-page-skeleton__shimmer" />
      </div>
    </div>
  );
}
